/**
 * Application configuration
 * Centralized place for all configurable values
 */

// ============ WISHLIST CONFIGURATION ============

export interface PriceGroup {
    id: string;
    label: string;
    min: number;
    max: number;
}

/**
 * Price groups for wishlist items categorization
 * Used on the main wishlist page to group items by price ranges
 */
export const PRICE_GROUPS: PriceGroup[] = [
    { id: 'under5k', label: 'До 5 000 ₽', min: 0, max: 5000 },
    { id: '5k-10k', label: 'От 5 000 до 10 000 ₽', min: 5000, max: 10000 },
    { id: '10k-25k', label: 'От 10 000 до 25 000 ₽', min: 10000, max: 25000 },
    { id: 'over25k', label: 'Более 25 000 ₽', min: 25000, max: Infinity },
];

// ============ UI CONFIGURATION ============

/**
 * Number of upcoming events to show on the events page
 */
export const UPCOMING_EVENTS_LIMIT = 10;

/**
 * Sidebar sticky position offset from top
 */
export const SIDEBAR_STICKY_TOP = 32; // pixels (2rem)

// ============ THEME CONFIGURATION ============

/**
 * Default theme when user hasn't made a selection
 */
export const DEFAULT_THEME: 'light' | 'dark' = 'dark';

/**
 * Local storage key for theme preference
 */
export const THEME_STORAGE_KEY = 'theme';

// ============ API CONFIGURATION ============

/**
 * Default cache settings for API requests
 */
export const API_CACHE_OPTIONS = {
    noStore: { cache: 'no-store' as const },
    revalidate: (seconds: number) => ({ next: { revalidate: seconds } }),
};

// ============ FORMATTING ============

/**
 * Currency formatting for RUB
 */
export const formatPrice = (price?: number): string => {
    if (!price) return '—';
    return new Intl.NumberFormat('ru-RU').format(price) + ' ₽';
};

/**
 * Date formatting
 */
export const formatDate = (date: Date | string): string => {
    const d = new Date(date);
    return d.toISOString().split('T')[0];
};

/**
 * Short date formatting (Russian locale)
 */
export const formatDateShort = (date: Date | string): string => {
    const d = new Date(date);
    return d.toLocaleDateString('ru-RU');
};
